import * as React from "react"

export const CheckCircleFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <mask
      id="a"
      width="48"
      height="48"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path fill="#D9D9D9" d="M0 0h48v48H0z"></path>
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M21.05 32.427 34.527 18.95l-1.742-1.712L21.05 28.992l-5.923-5.923-1.692 1.712zM24.003 43q-3.91 0-7.37-1.496a19.3 19.3 0 0 1-6.049-4.086 19.3 19.3 0 0 1-4.087-6.046Q5 27.914 5 24.003q0-3.942 1.496-7.41t4.085-6.034q2.59-2.566 6.047-4.062Q20.086 5 23.997 5q3.942 0 7.41 1.496t6.034 4.06q2.565 2.564 4.062 6.032Q43 20.054 43 23.997q0 3.91-1.496 7.37-1.495 3.458-4.06 6.049t-6.032 4.087Q27.946 43 24.003 43"
      ></path>
    </g>
  </svg>
)
